module.exports = __webpack_public_path__ + "img/private.7a589fa.svg";